import React, { useState, useEffect } from "react";
import { Section, TwoColumnStack } from "@arp/react-ndbx";

//** Config */
import {
  questionTypes,
  questionLabels,
} from "../../../config/questions/questionItems.js";
import { yourDetailsContactFieldNames } from "../../../config/pageInfo/pageFieldName";

//** App components */
import ToggleButtonNotification from "../../../components/organisms/ToggleButtonNotification.jsx";
import ToggleButtonCheckbox from "../../../components/organisms/ToggleButtonCheckbox.jsx";

//** Context */
import { useOutletContext } from "react-router-dom";
import { useWatch } from "react-hook-form";

const ContactInformationQuestions = ({ ...props }) => {
  const { person, dataSet, insuranceTypeItems, notificationItems } = {
    ...props,
  };

  const {
    methods: [methods],
    showSecond: [showSecond],
  } = useOutletContext();

  const { control, resetField } = { ...methods };

  // ****************************************************************
  const [showOtherAllianzInsurance, setShowOtherAllianzInsurance] =
    useState(false);

  const [clearForm, setClearForm] = useState(false);

  const allianzInsuranceWatch = useWatch({
    control,
    name: yourDetailsContactFieldNames(person).OTHER_ALLIANZ_INSURANCE_QUESTION,
  });

  const [insuranceTypeDefaultValues, setInsuranceTypeDefaultValues] = useState(
    dataSet[person].otherAllianzInsuranceList
  );

  useEffect(() => {
    const outputAllianzInsuranceQuestion = allianzInsuranceWatch === "yes";
    setShowOtherAllianzInsurance(outputAllianzInsuranceQuestion);

    setClearForm(!outputAllianzInsuranceQuestion);
  }, [allianzInsuranceWatch]);

  //! Show second - Not currently in use.
  useEffect(() => {
    if (showSecond === false) {
      resetField(yourDetailsContactFieldNames("personTwo").TOBACCO_QUESTION, {
        defaultValue: null,
      });
      resetField(
        yourDetailsContactFieldNames("personTwo")
          .OTHER_ALLIANZ_INSURANCE_QUESTION,
        {
          defaultValue: null,
        }
      );
      resetField(
        yourDetailsContactFieldNames("personTwo").OTHER_ALLIANZ_INSURANCE_LIST,
        {
          defaultValue: [],
        }
      );
    }
  }, [showSecond]);

  // ****************************************************************

  return (
    <Section md={12} mt={5} id="your-details-personal">
      <TwoColumnStack
        name="your-details-contact-toggle-questions"
        sx={{ alignItems: { xs: "center", md: "flex-start" } }}
      >
        <ToggleButtonNotification
          dataSetItem={dataSet[person].tobaccoQuestion}
          fieldName={yourDetailsContactFieldNames(person).TOBACCO_QUESTION}
          label={questionLabels.TOBACCO_QUESTION}
          items={questionTypes.YES_NO}
          showNotification={false}
          showTooltip={false}
          sx={{ textAlign: "center" }}
        />

        <ToggleButtonCheckbox
          dataSetItem={dataSet[person].otherAllianzInsuranceQuestion}
          fieldName={
            yourDetailsContactFieldNames(person)
              .OTHER_ALLIANZ_INSURANCE_QUESTION
          }
          label={questionLabels.OTHER_INSURANCE_QUESTION}
          items={questionTypes.YES_NO}
          showCheckboxList={showOtherAllianzInsurance}
          showTooltip={false}
          options={insuranceTypeItems}
          defaultValue={insuranceTypeDefaultValues}
          checkboxFieldName={
            yourDetailsContactFieldNames(person).OTHER_ALLIANZ_INSURANCE_LIST
          }
          checkboxLabel="Insurance type"
          notificationItems={notificationItems}
          methods={methods}
          clearForm={clearForm}
        />
      </TwoColumnStack>
    </Section>
  );
};

export default ContactInformationQuestions;
